import { Spinner } from "@ucl/react-library";
import {Text} from "@ucl/react-library";
import { useTranslation } from "react-i18next";

type LoaderProps = {
  title?: string;
  subtitle?: string;
}

export const Loader = ({ title, subtitle}: LoaderProps) => {

  const { t }= useTranslation();


  return (
    <div className="flex flex-col justify-center items-center bg-white fixed inset-0 gap-4 p-10 z-10" data-testid={"loader"}>
      <Spinner size="large" variant="onColor" aria-label="loading-screen" />
      <div className="flex flex-col gap-2 text-center">
        <Text renderAs="h1" styleType="h4">{title ? title : t("loadingScreen.title")}</Text>
        <Text.P size="large">{subtitle ? subtitle : t("loadingScreen.subtitle")}</Text.P>
      </div>
    </div>
  );
};